var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAlertCircleArcade = function SvgAlertCircleArcade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#D3040E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.75 21.5a1.75 1.75 0 1 0-3.5 0V34a1.75 1.75 0 1 0 3.5 0V21.5Zm-4.25 20a2.5 2.5 0 0 0 5 0 2.5 2.5 0 0 0-5 0Z",
    fill: "#fff"
  })));
};

export default SvgAlertCircleArcade;